import Api from './api.service'

import Configuration from '@/configuration';
const baseURL = Configuration.value('apiFrontend')

export default {
  get() {
    return Api().get(`${baseURL}/cart`)
  },
  addToCart(vehicleId) {
    return Api().post(`${baseURL}/cart/${vehicleId}`)
  },
  addPackageToCart(packageId) {
    return Api().post(`${baseURL}/cart/package/${packageId}`)
  },
  remove(id) {
    return Api().delete(`${baseURL}/cart/${id}`)
  },
  removePackage(id) {
    return Api().delete(`${baseURL}/cart/package/${id}`)
  },
  getCount() {
    return Api().post(`${baseURL}/cart/count`)
  },
  buy(payload) {
    return Api().post(`${baseURL}/cart/buy`, payload)
  },
  checkStock() {
    return Api().post(`${baseURL}/cart/check-stock`)
  }
}
